$(document).ready(function () {
  $(".regulations-new-indent").css({
    left: $(".regulations-new").width() + 20,
  });

  $(".regulations-old-indent").css({
    left: $(".regulations-old").width() + 20,
  });

  $(".liquid-new-indent").css({
    left: $(".liquid-new").width() + 20,
  });

  $(".liquid-old-indent").css({
    left: $(".liquid-old").width() + 20,
  });
});

